
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/mobileServiceSelector',[
    'Vue','vue!./serviceItem','vuex'
  ], function (
    Vue,
    serviceItem,
    vuex
  ) {
    return {
      template: template,
      name: "",
      props: ['handleCategoryClick','categoriesToShow', 'durationMatchingServices', 'filteredServices'],
      data: function () {
        return {}
      },
      computed: _.extend(vuex.mapState(['activeCategory','services','packages','desktopMode','mobileCategoryShow','allCategories', 'OTBactive', 'usersWithIds', 'users']),
      {
        serviceHeader:function(){
             return !this.mobileCategoryShow ? this.activeCategory :this.localStrings.stepper.body.pick.serviceHeaderText
        },
        activeStep: function(){
                    return this.$store.state.activeStep
        }
      }),
      components: { 'service-item': serviceItem},
      methods: {
          handleCategoryclick:function(category){
              this.handleCategoryClick(category)
          },
          goBack: function() {
              if(!this.desktopMode && !this.mobileCategoryShow && this.activeStep==0){
                this.$store.commit('setmobileCategoryShow',!this.mobileCategoryShow)
              }
          }
      },
    }
  })
})('<div class="packageSelectionContainerMobile"> <div class="serviceSelectionHeader"> <i class="fas fa-arrow-left vue-cart-back-icon" v-on:click="goBack" aria-label="Go Back" v-show=" !desktopMode && !mobileCategoryShow && OTBactive"></i><span>{{serviceHeader}}</span> </div> <div id="stepper-categories" v-show="mobileCategoryShow"> <div class="app-body-header"><b>{{localStrings.stepper.body.pick.categoryHeader}}</b></div> <div class="componentItem" :key="index" role="button" aria-label="Select Category" v-on:click="handleCategoryclick(category)" :class="category==activeCategory?\'active\':null" v-for="(category,index) in categoriesToShow">{{ category }} </div> </div> <transition name="fade" mode="out-in"> <div id="stepper-services" v-show="!mobileCategoryShow"> <span class="bookingFor" v-show="OTBactive"><b>{{this.localStrings.stepper.body.schedule.bookingForText}}</b> {{usersWithIds[Object.keys(users)[0]]}}</span> <div class="accordion" id="accordion2"> <service-item :key="service.SpaItemId" :package_item="packages[service.SpaItemId]" v-for="service in filteredServices[activeCategory]" v-bind:service="service"></service-item> <service-item v-show="durationMatchingServices" :key="service[0].nameWoDuration" :package_item="packages[service.SpaItemId]" v-for="(service,index) in durationMatchingServices[activeCategory]" v-bind:service="service" :index="index" :lastIndex="durationMatchingServices[activeCategory].length-1"></service-item> </div> </div> </transition> </div>');
